import type { SellerGroupUser } from '@seller-hermes/features/seller-group';
import { PROFILE_TYPES } from '@seller-hermes/utils/profileTypes';

// Leitura do usuário do /me tolerante a campo ausente: a API devolve
// `profile_module: null` (e listas vazias) pra conta sem módulo configurado.
// Use estas funções em vez de acessar `user.seller_group.profile_module.name`
// direto — esse acesso derrubou a tela de Pedidos (sandbox, 20/10). O teste
// user-access.guard.spec.ts falha se o acesso direto voltar a aparecer.

export const hasAnyPermission = (
  user: SellerGroupUser | null,
  permissions: any[],
) => {
  if (!user) return false;
  return permissions.some((permission) => user?.all_permissions?.[permission]);
};

export const hasProfilePermission = (
  user: SellerGroupUser | null,
  permissions: any[],
) => {
  if (!user) return false;
  return permissions.some(
    (permission) => user?.profile_permissions?.[permission],
  );
};

export const hasHiredModulesPermission = (
  user: SellerGroupUser | null,
  permissions: any[],
) => {
  if (!user) return false;
  return permissions.some(
    (permission) => user?.hired_modules_permissions?.[permission],
  );
};

export const hasHiredModules = (
  user: SellerGroupUser | null,
  modules: string[],
) => {
  if (!user || !user.seller_group?.hired_modules) return false;
  return user.seller_group.hired_modules.some((hiredModule) =>
    modules.some((module) =>
      hiredModule.feature_module?.name?.includes(module),
    ),
  );
};

export const hasProfile = (
  user: SellerGroupUser | null,
  profile: PROFILE_TYPES,
) => {
  return user?.seller_group?.profile_module?.name === profile;
};
